// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1323) return "static/chunks/1323-8739517f4d376023.js";
	if (chunkId === 8111) return "static/chunks/8111-0dec325b654d74ab.js";
	if (chunkId === 2563) return "static/chunks/2563-b656fb2b191d6d05.js";
	if (chunkId === 6281) return "static/chunks/6281-05292ec5ea5afa3a.js";
	if (chunkId === 5404) return "static/chunks/5404-855e5f031eb9bf9d.js";
	if (chunkId === 7182) return "static/chunks/7182-f48213b2ebae7c0b.js";
	if (chunkId === 7838) return "static/chunks/7838-7cde7d98d11bfa4c.js";
	if (chunkId === 6090) return "static/chunks/6090-b92a88f9a5e9ffb7.js";
	if (chunkId === 2535) return "static/chunks/2535-d457e13f31e6b137.js";
	if (chunkId === 5658) return "static/chunks/5658-9182c05077aca771.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"91":"13a6d904e7d4c27b","554":"39df229553c71453","760":"d7cc6fcd96aa77e6","1056":"771d2636b9adbbc7","2922":"3677e3a56921a269","4739":"39edf7755730daa7","5319":"20504f2c957fa521","6024":"36d13ee4bdb331b2","8309":"bf0bda49766b4a24","8855":"3b8a01e72c2c3533","9291":"31c656630dfd7623"}[chunkId] + ".js";
};